import _ from 'lodash'
import {parseQueryParams} from '../wixCodeUrlUtils'
import {experiment} from '../../../experiment/experiment'
const WIX_CODE_APP_DEF_ID = '675bbcef-18d8-41f5-800e-131ec9e08762'
const WIX_CODE_APP_DEF_ID_NEW = '2f70e2b4-ff36-472e-bdb9-ce393b13669e'
const getWixCodeInstanceId = clientSpecMap => {
    if (experiment.isOpen('dm_cloudSiteExtensionMigrationDev')) {
        return (
            _.get(_.find(clientSpecMap, {appDefinitionId: WIX_CODE_APP_DEF_ID_NEW}), 'instanceId') ||
            _.get(_.find(clientSpecMap, {appDefinitionId: WIX_CODE_APP_DEF_ID}), 'instanceId')
        )
    }
    return _.get(_.find(clientSpecMap, {appDefinitionId: WIX_CODE_APP_DEF_ID}), 'instanceId')
}

const getter = (dataPath, {rendererModel, clientSpecMap, serviceTopology, currentUrl}) => {
    if (!rendererModel) {
        return ''
    }

    const wixCodeGridId = rendererModel.wixCodeModel.appData.codeAppId
    const wixCodeInstanceId = getWixCodeInstanceId(clientSpecMap)
    const queryParams = currentUrl ? parseQueryParams(currentUrl) : {}
    const bundlerUrlOverrideQueryParam = queryParams['app-studio-bundler-override']
    const baseUrl =
        bundlerUrlOverrideQueryParam ||
        `https://${wixCodeInstanceId}.static.pub.${serviceTopology.wixCloudBaseDomain}/static/v2`

    return `${baseUrl}/${wixCodeGridId}/${wixCodeInstanceId}/appstudio.viewer.js?module-name=bundle`
}

export default getter
